import { useCallback, useContext } from 'react';
import { OptimisticPromiseContext } from 'contexts/OptimisticPromiseContext';
import { isOptimistic } from '../utils/idNormalization';

export function useOptimisticPromise() {
  const promiseMapRef = useContext(OptimisticPromiseContext);
  
  const extractId = (data) => data.excerpt?.id || data.code?.id;
  
  const setPromise = useCallback((optimisticId, promise) => {
    // Transform the promise to resolve to just the ID
    const idPromise = promise.then(data => {
      const resolvedId = extractId(data);
      return resolvedId;
    });
    
    // Store the ID promise
    promiseMapRef.current.set(optimisticId, idPromise);
    
    // Clean up after resolution
    idPromise.catch((error)=>{}).finally(() => {
      setTimeout(() => {
        promiseMapRef.current.delete(optimisticId);
      }, 10000);
    });
  }, []);
  
  const waitForPromise = useCallback(async (id) => {
    if (!isOptimistic(id)) {
      return id;
    }
    
    const idPromise = promiseMapRef.current.get(id);
    if (idPromise) {
        return await idPromise;
    }
    
    return id;
  }, []);
  
  return { setPromise, waitForPromise };
}